import styled from 'styled-components';

export const FailedStepsStyled = styled.div``;
export const TestCycleLinkStyled = styled.a`
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));

  &:hover {
    color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
  }
`;
